import { FC, PropsWithChildren } from "react";

const Title: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <h1 className="Title">{children}</h1>
      {/* language=CSS */}
      <style jsx>
        {`
          .Title {
            text-align: center;
            font-weight: normal;
          }
        `}
      </style>
    </>
  );
};

export default Title;
